import { render } from "./country-management.vue?vue&type=template&id=3a679ea4&ts=true"
import script from "./country-management.ts?vue&type=script&lang=ts&external"
export * from "./country-management.ts?vue&type=script&lang=ts&external"

import "./country-management.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__